const recaptchaEl = document.querySelector('[name="g-recaptcha-hidden"]')
if (recaptchaEl) {
  recaptchaEl.id = 'recaptchaContact'

  const labelEl = document.createElement('label')
  labelEl.setAttribute('for', 'recaptchaContact')
  labelEl.classList.add('recaptcha-label')
  labelEl.innerHTML = 'Recaptcha'

  recaptchaEl.after(labelEl)
}